import isEmpty from 'lodash.isempty';
import getCustomColorPalette from '../selectors/custom-color-palette';
import { connectedStore } from '../../store';
import getColorPalette from '../selectors/color-palette';
import constants from '../constants';
import globals from '../../globals';
import template from '../../template';

const getCurrentColorPalette = () => {
  const store = connectedStore.get();
  const state = store.getState();

  const colorPaletteVariable = template.selectors.getVariableValueByPath(
    state,
    constants.COLOR_PALETTE_VARIABLE
  );

  if (isEmpty(colorPaletteVariable)) return null;

  const variable = colorPaletteVariable.find((item) => item.querySelector);

  if (!variable) return null;

  const globalNode = globals.operations.extractGlobalContent('header-code');
  if (!globalNode) return null;

  const element = globalNode.querySelector(variable.querySelector);
  if (!element) return null;

  const currentPaletteId = element.getAttribute(constants.COLOR_PALETTE_DATA_ATTRIBUTE);

  const customPalette = getCustomColorPalette(state, currentPaletteId);

  if (customPalette) return customPalette;

  return getColorPalette(state, currentPaletteId);
};

export default getCurrentColorPalette;
